/** Spatial layout for the greybox park. Costs and unlocks live in balancing.ts. */

export const PARCEL_START = 'parcel_start';
export const PARCEL_EAST = 'parcel_east';
export const PARCEL_NORTH = 'parcel_north';

export interface SlotDef {
  id: string;
  parcelId: string;
  col: number;
  row: number;
}

export interface GridCell {
  col: number;
  row: number;
}

export const PARCELS = [
  { id: PARCEL_START, startsUnlocked: true, label: 'Park' },
  { id: PARCEL_EAST, startsUnlocked: false, label: 'East lawn' },
  { id: PARCEL_NORTH, startsUnlocked: false, label: 'North ridge' },
] as const;

export const SLOTS: SlotDef[] = [
  { id: 'slot_a1', parcelId: PARCEL_START, col: 0, row: 1 },
  { id: 'slot_a2', parcelId: PARCEL_START, col: 1, row: 1 },
  { id: 'slot_a3', parcelId: PARCEL_START, col: 0, row: 2 },
  { id: 'slot_a4', parcelId: PARCEL_START, col: 1, row: 2 },
  { id: 'slot_a5', parcelId: PARCEL_START, col: 0, row: 3 },
  { id: 'slot_a6', parcelId: PARCEL_START, col: 1, row: 3 },
  { id: 'slot_b1', parcelId: PARCEL_EAST, col: 3, row: 1 },
  { id: 'slot_b2', parcelId: PARCEL_EAST, col: 4, row: 1 },
  { id: 'slot_b3', parcelId: PARCEL_EAST, col: 3, row: 2 },
  { id: 'slot_b4', parcelId: PARCEL_EAST, col: 4, row: 2 },
  { id: 'slot_c1', parcelId: PARCEL_NORTH, col: 3, row: -1 },
  { id: 'slot_c2', parcelId: PARCEL_NORTH, col: 4, row: -1 },
  { id: 'slot_c3', parcelId: PARCEL_NORTH, col: 3, row: 0 },
  { id: 'slot_c4', parcelId: PARCEL_NORTH, col: 4, row: 0 },
  { id: 'slot_c5', parcelId: PARCEL_NORTH, col: 5, row: 1 },
  { id: 'slot_c6', parcelId: PARCEL_NORTH, col: 5, row: 2 },
];

export const PATH_CELLS: GridCell[] = [
  { col: 2, row: -1 },
  { col: 2, row: 0 },
  { col: 2, row: 1 },
  { col: 2, row: 2 },
  { col: 2, row: 3 },
];

export const ENTRANCE: GridCell = { col: 2, row: 4 };

/** Visitor patrol points in grid space, entrance first. */
export const WAYPOINTS: GridCell[] = [
  ENTRANCE,
  { col: 2, row: 3 },
  { col: 2, row: 2 },
  { col: 2, row: 1 },
  { col: 2, row: 0 },
  { col: 2, row: -1 },
  { col: 2, row: 0 },
  { col: 2, row: 1 },
  { col: 2, row: 2 },
  { col: 2, row: 3 },
];

export function slotById(slotId: string): SlotDef | undefined {
  return SLOTS.find((slot) => slot.id === slotId);
}

export function slotsForParcel(parcelId: string): SlotDef[] {
  return SLOTS.filter((slot) => slot.parcelId === parcelId);
}

export function parcelById(parcelId: string): (typeof PARCELS)[number] | undefined {
  return PARCELS.find((parcel) => parcel.id === parcelId);
}

export function parcelCentroid(parcelId: string): { col: number; row: number } {
  const slots = slotsForParcel(parcelId);
  const col = slots.reduce((sum, slot) => sum + slot.col, 0) / slots.length;
  const row = slots.reduce((sum, slot) => sum + slot.row, 0) / slots.length;
  return { col, row };
}
